/* =====================================================================
   ZZ Announcement — centered vertical/fade autoplay rotator.
   Cycles .zz-ann__item (one visible at a time). Mode (slide/fade) is
   driven by a CSS class on the root; this JS is mode-agnostic.
   - active item gets .is-active, the leaving one .is-prev
   - pause on hover/focus, respects prefers-reduced-motion
   Idempotent; re-inits on Shopify section load.
   ===================================================================== */
(function () {
  'use strict';

  function prefersReduced() {
    return window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(el) {
    if (!el || el.__zzAnnInit) return;
    el.__zzAnnInit = true;

    var items = Array.prototype.slice.call(el.querySelectorAll('.zz-ann__item'));
    if (items.length < 2) return;

    var delay = parseInt(el.getAttribute('data-autoplay'), 10) || 5000;
    var idx = items.findIndex(function (it) {
      return it.classList.contains('is-active');
    });
    if (idx < 0) { idx = 0; items[0].classList.add('is-active'); }

    var timer = null;

    function show(next) {
      if (next === idx) return;
      items.forEach(function (it) { it.classList.remove('is-prev'); });
      items[idx].classList.remove('is-active');
      items[idx].classList.add('is-prev');
      items[next].classList.add('is-active');
      idx = next;
    }

    function tick() { show((idx + 1) % items.length); }

    function start() {
      if (!timer && !prefersReduced()) timer = window.setInterval(tick, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);

    start();
  }

  function boot() {
    document.querySelectorAll('[data-zz-ann]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector
      ? e.target.querySelector('[data-zz-ann]')
      : null;
    if (el) init(el);
  });
})();
